import { action, observable, runInAction, computed } from 'mobx';

import agent from '../api/agent';
import { IAgent } from '../models/agent';
import { IOption } from '../models/option';
import { RootStore } from './rootStore';

export default class AgentStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable agentOptions: IOption[] = [];
  @observable agentRegistry = new Map();
  @observable loading = false;

  @computed get agentFilterOptions() {
    const options = Array.from(this.agentOptions.values());
    options.unshift({ key: '', value: '', text: '' });
    return options;
  }

  @action loadAgents = async () => {
    this.loading = true;
    try {
      const agents = await agent.Agents.list();
      runInAction('loading Agents', () => {
        agents.forEach((agent) => {
          this.agentRegistry.set(agent.agentId, agent);
        });
        this.agentOptions = agents.map((item: IAgent) => ({
          key: item.agentId,
          value: item.agentName,
          text: item.agentName,
        }));
        this.loading = false;
      });
    } catch (error) {
      runInAction('load Agents error', () => {
        this.loading = false;
      });
    }
  };

  @action loadAgent = (key: string) => {
    return this.agentRegistry.get(key);
  };
}
